
import { Component, Prop, Vue } from "vue-property-decorator";
import anime from "animejs";

@Component
export default class FeatureGrid extends Vue {

  mounted() {
    // Cards
    let loadedGrid = false;
    new IntersectionObserver((entries) => {
      if (entries[0].intersectionRatio <= 0) return;
      if (!loadedGrid) {
        loadedGrid = true;
        anime({
          targets: ["#card1"],
          translateX: -400,
          direction: 'reverse',
          duration: 1000,
          color: 'rgba(0, 0, 0, 0)',
          easing: 'easeInOutSine',
          delay: 1000
        });
        anime({
          targets: ["#card2"],
          translateX: 400,
          duration: 1000,
          direction: 'reverse',
          color: 'rgba(0, 0, 0, 0)',
          easing: 'easeInOutSine',
          delay: 1000
        });
        anime({
          targets: ["#card3"],
          translateX: -600,
          direction: 'reverse',
          duration: 1200,
          color: 'rgba(0, 0, 0, 0)',
          easing: 'easeInOutSine',
          delay: 3500
        });
        anime({
          targets: ["#card4"],
          translateX: 600,
          duration: 1200,
          direction: 'reverse',
          color: 'rgba(0, 0, 0, 0)',
          easing: 'easeInOutSine',
          delay: 3500
        });
      }}).observe(this.$el.querySelector('.feature-grid') as Element);

      // Letters
      let loadedBut = false;
      new IntersectionObserver((entries) => {
      if (entries[0].intersectionRatio <= 0) return;
      if (!loadedBut) {
        loadedBut = true;
        anime({
          targets: ["#but", "#how"],
          translateY: 200,
          duration: 1000,
          direction: 'reverse',
          color: 'rgba(0, 0, 0, 0)',
          easing: 'easeInOutSine',
          delay: 1000
        });
      }}).observe(this.$el.querySelector('#but') as Element);
  }
}
